// components/schema/SchemaEditor.jsx

import React from "react"
import Editor from "@monaco-editor/react"
import { PGS_LANGUAGE_ID } from "./pgs-language"

export default function SchemaEditor({
  code,
  setCode,
  editorTheme,
  handleEditorWillMount,
  handleEditorDidMount,
}) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700">
      <Editor
        height="50vh"
        language={PGS_LANGUAGE_ID}
        theme={editorTheme}
        value={code}
        onChange={(v) => setCode(v ?? "")}
        beforeMount={handleEditorWillMount}
        onMount={handleEditorDidMount}
        options={{
          fontSize: 14,
          minimap: { enabled: false },
          wordWrap: "on",
          tabSize: 2,
          insertSpaces: true,
          automaticLayout: true,
        }}
      />
    </div>
  )
}
